import { handleActions } from '../../helpers/immer';
import * as action from '../../actions/Shortlist';

const initialValue = {
  loading: false,
  initialized: false,
  items: [],
  error: null,
};

export const shortlist = handleActions(
  {
    [action.shortlistLoading]: (draft, { payload }) => {
      draft.loading = payload;
      if (!payload) draft.initialized = true;
    },
    [action.setShortlist]: (draft, { payload }) => {
      draft.items = Array.isArray(payload) ? payload : [];
      draft.error = null;
    },
    [action.setShortlistError]: (draft, { payload }) => {
      draft.error = payload || null;
    },
  },
  initialValue
);
